import React, {  useState,useRef, useEffect } from 'react';
import axios from 'axios';
import Modal from '../Modal';
import Locations from './CVLocations';
import { getUserId,aPIURL,auTHURL } from '../../utils/common';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import LoadingSpinner from "../LoadingSpinner";
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
//import Enumerate from "linq";


const Alert = () => 
{
    const fileType ="xlsx";
    const [SNo,setSNo]=useState("");
    let [advPriority, setAdvPriority] = useState("");
    let [advAlertType, setAdvAlertType] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);
    const API_URL=aPIURL();
    const AUTH_URL= auTHURL();
    const [userId, setUserId]  = useState({});
    const [custID, setCustID]  = useState('0');
    const [dIMEINo, setDIMEINo]  = useState('0'); 
    const [devName, setDevName]  = useState(""); 
    const [dID, setDID]  = useState('0');
    const [vCategoryID, setVCategoryID]  = useState('0');
    const [ignitionType ,setIgnitionType] = useState(1);
    const [post, setPost] = useState([]);
    const [deviceData , setDeviceData]  =useState([]);
    const [vCategoryData,setVCategoryData ]  =useState([]);
    const [showDetails,setShowDetails ]  = useState(false);
    const [vehicleNo,setVehicleNo]=useState(0);
    const [alertId, setAlertId]=useState(0);
    const [vehicleData,setVehicleData] =useState([]);
    const [order, setOrder] = useState("ASC");
    const [number, setNumber] = useState(1); // No of pages
    const [postPerPage] = useState(10);
    const AccountID =getUserId(); 
    let [temeratureValue,setTemeratureValue]=useState(0);
    const [alertData,setAlertData] =useState([]);
    
    const [maintenanceStatusDisplay,setMaintenanceStatusDisplay]  = useState('none');
    const [unauthorizedUsageDisplay,setUnauthorizedUsageDisplay] = useState('none'); 
    const [geoFenceDisplay,setGeoFenceDisplay] = useState('none');
    const [speedingDisplay,setSpeedingDisplay] = useState('none');
    const [landMarkDisplay,setLandmarkDisplay] = useState('none');
    const [ignitionOnDisplay,setIgnitionOnDisplay] = useState('none');
    const [excessIdleDisplay,setExcessIdleDisplay] = useState('none');
    const [longStopDisplay,setLongStopDisplay] = useState('none');
    const [lateStartDisplay,setLateStartDisplay] = useState('none');
    const [highTemperatureDisplay,setHighTemperatureDisplay]  = useState('none');
    const [lowTemperatureDisplay,setLowTemperatureDisplay]  = useState('none');
    const [expiredDeviceDisplay,setExpiredDeviceDisplay] = useState('none');
    const [inputs, setInputs] = useState({});
  
  
    let [arrayPriority, setarrayPriority] = useState([]);
    let [arrayAlertType, setarrayAlertType] = useState([]);
    const [statusId, setStatusId]= useState(0);
  const sorting=(col)=>
  {

    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }  
            
  }


  useEffect(() => 
  {    
           FillGrid(0);    
  }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
 
const FillGrid=(Type_ID)=>
{
    setIsLoading(true);
    //const Type_ID=0;
    const url=API_URL+`MessageList/?AccountID=${AccountID}&TypeID=${Type_ID}`;         
   
   // alert(url); 
    
    setPost([]); 
    axios.get(url).then(response => 
      {  
          setIsLoading(false);
          console.log(response.data.data);        
          setPost(response.data.data)   
          console.log("===============================uniquelist==================================================");       
          
          let ids = {};
            response.data.data.forEach(obj => 
              {
                if (!ids[obj.priorities]) 
                  {
                    ids[obj.priorities] = true;
                    arrayPriority.push(obj);
                }
            });
         let ids2 = {};
            response.data.data.forEach(obj => 
              {
                if (!ids[obj.alertType]) 
                  {
                    ids[obj.alertType] = true;
                    arrayAlertType.push(obj);
                }
            });
            
           
      }).catch(function(error) 
      {
        setIsLoading(false);
            console.log(error.message);
      
      });
}  

const changeHandler = (e) => 
  {   
      setSNo(e.target.value)
  } 

  const ChangeSourceAddress = (e) => 
    {
      if(e.target.value=='Select Priority Type')
        {setAdvPriority("");
        }
        else{setAdvPriority(e.target.value);}
      
    }
    const ChangeEndAddress = (e) => 
    {
      if(e.target.value=='Select Alert Type')
      {setAdvAlertType("");}else{setAdvAlertType(e.target.value);}
    }

  
  
  const ResetTripList=()=>
    {
      setAdvPriority("");
      setAdvAlertType("");
      setSNo(""); 
      setIsLoading(true);
    
    const url=API_URL+`MessageList/?AccountID=${AccountID}&TypeID=0`;   
    setPost([]); 
    axios.get(url).then(response => 
      {  
          setIsLoading(false);
          console.log(response.data.data);        
          setPost(response.data.data)         
           
      }).catch(function(error) 
      {
        setIsLoading(false);
            console.log(error.message);      
      });    
      
    }

const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };
       
  const FilterGrid =() => 
    {
        
      const Account_ID = getUserId(); 
      const searchparams = JSON.stringify({
        "accountid": Account_ID,
        "VehicleNumber":SNo.trim(),
        "PeriorityType":advPriority,
        "AlertType": advAlertType,
        "OrderBy": ""
      });
  
      
      //alert(searchparams)
      setPost([]);  
      axios.post(API_URL+'GpsSearchAlertAdvance/', searchparams,
      {  
        "headers":{"content-type": "application/json",},})
     .then(function (response) 
     {    
         
          setPost(response.data.data);      
          console.log(response.data.data);
     })
     .catch(function (error) 
     {
           toast.info("No data found !");
     });
  
    }
    /*
const showDetailsModal = () => 
{      
       setShowDetails(true); 
       const vurls=API_URL+`VehicleList/?AccountID=${AccountID}&TypeID=0`;    
        //alert(vurls);
        axios.get(vurls).then(response =>
             {                  
                    const updatedList =  response.data.data.filter((curElem) => {
                    //console.log(curElem);
                    return curElem.status === "Enabled";
              });   
                   setVehicleData(updatedList);                    

             }).catch(function(error) {  console.log(error.message); });

            //setAlertData
            const Alurl = API_URL+`GetAlertTypes/?AccountID=0`;        //Zero meanse all alert list    
            //alert(url);  
            setAlertData([]); 
            axios.post(Alurl).then(response => 
            {  
                //console.log(response.data.data);        
                setAlertData(response.data.data)   
           
      }).catch(function(error) { console.log(error.message);  });
                         
            
}


const closeModal = () => 
{
        setShowDetails(false);       
       
}
*/
const exportStatus = e => {
 
  const value = e.target.value; 
  setStatusId(e.target.value);
  FillGrid(value);
}
const exportToCSV=()=>
  {
    const newPost = post.map(({ acc,accountID,contactNumber,deviceID,deviceName,driverName,iS_Active,iS_Read,imeiNumber,lastUpdated,latitude,longitude,msgid,sender,speed,vehicleTypeID, ...rest }) => rest);
     const ws= XLSX.utils.json_to_sheet(newPost);        
     var wscols = [
        {wch:5} ,
        {wch:20},
        {wch:20},
        {wch:60},
        {wch:20},
        {wch:20},
        {wch:20},         
        {wch:20}
    ];
 
    var wsrows = [
       {hpx: 30}
    ];
    
    ws['!cols'] = wscols;
    ws['!rows']=wsrows;
         
    let Heading = [['S.No.','Vehicle Number','Status','Alert Description','Alert Type','Received Date','Aknowledge Date','Priorities']];
    const wb={Sheets:{Alerts:ws},SheetNames:["Alerts"]};
    XLSX.utils.sheet_add_aoa(ws, Heading);     
    const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
    const data= new Blob([excelBuffer],{type:fileType});
    FileSaver.saveAs(data,"AvtAlertsReport"+".xlsx");
   }
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  //alert(value)

  if(value=="Excel")
  {
        exportToCSV();   
       //onDownload();
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}
/* const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "Alert Details",
  sheet: "Alerts"
}); */
const ChangeVehicleNo = (e) => {
  //alert(e.target.value);
  setVehicleNo(e.target.value);
}
/* const ChangeAlertId= (e) => {
         
         setAlertId(e.target.value);
         if(e.target.value == 3)
         {
                setMaintenanceStatusDisplay('block');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 6)
         {
                setUnauthorizedUsageDisplay('block');
                setMaintenanceStatusDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 8)
         {
                setGeoFenceDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 9)
         {
                setSpeedingDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
               
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 10)
         {
                setLandmarkDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 11)
         {
                setIgnitionOnDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 12)
         {
                
                setExcessIdleDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 13)
         {
                
                setLongStopDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 14)
         {
                
                setLateStartDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 15)
         {
                
                setHighTemperatureDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                
                setLowTemperatureDisplay('none');
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 17)
         {
                
                setLowTemperatureDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                
                setExpiredDeviceDisplay('none');
         }
         else if(e.target.value == 18)
         {
               
                setExpiredDeviceDisplay('block');
                setMaintenanceStatusDisplay('none');
                setUnauthorizedUsageDisplay('none');
                setGeoFenceDisplay('none');
                setSpeedingDisplay('none');
                setLandmarkDisplay('none');
                setIgnitionOnDisplay('none');
                setExcessIdleDisplay('none');
                setLongStopDisplay('none');
                setLateStartDisplay('none');
                setHighTemperatureDisplay('none');
                setLowTemperatureDisplay('none');
                
         }
         else
         {
              //alert("n/a");
         }
}
*/
const changeVHandler = (event) => {
 
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
  
}
const SaveAlert=()=>
{
   alert("Save");
}
const setIgnition_Type =(event) =>
{
     if(event.target.value==1)
     {
        setIgnitionType(1);               
     }
     else
     {
        setIgnitionType(2);         
     } 
     
}
const changeRangeHandler = (e) => {

  setTemeratureValue(e.target.value);
}
const handlePrint = useReactToPrint({
  documentTitle: "Alert Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});
const styles = {
headsection: {
    backgroundColor:"black", color:"white",textAlign:"center"
},
tcaption: {
    textAlign:"left",fontWeight:"bold","vertical-align": "middle",width:"15%"
}
}
//if (isLoading) 
 // {
   // return <center>< LoadingSpinner/></center> ;
 // }
return (
    <>
{/*Alert Settings Popup*/}          
{/*<Modal isOpen={showDetails} >  
              <div  class="modal-header">
              <h5 className='modal-title'>Alert Settings</h5>
              <button type="button" class="btn-close" onClick={closeModal}></button>
              </div>
              <div class="modal-body"> 
              <div class="row">
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              Vehicle : <span style={{color:"red"}}>&nbsp;*</span>        
              <select className="form-control"  name="DVehicleNo" value={vehicleNo} onChange={ChangeVehicleNo} >
              <option value={0}>Select</option>
              {vehicleData.map((e, key) => {
                return <option key={key} value={e.deviceID}>{e.vehicleNumber}</option>;
              })}
              </select> 
		          </div>  
              <div class="col-sm-6 col-md-4 form-group">&nbsp;
              Alert Type : <span style={{color:"red"}}>&nbsp;*</span>        
              <select className="form-control"  name="DAlertType" value={alertId} onChange={ChangeAlertId} >
              <option value={0}>Select</option>
              {alertData.map((e, key) => {
              return <option key={key} value={e.alertTypeID}>{e.alertType}</option>;
              })}
              </select> 
		          </div>  
              <div class="col-sm-6 col-md-4 form-group" style={{display: maintenanceStatusDisplay }}>&nbsp;
              Maintenance Date : 
              <input type="date" className="form-control" value={inputs.manitenancedate}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>&nbsp;
              Time From : <br/>
              <input type="time" className="form-control" value={inputs.timefrom}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: unauthorizedUsageDisplay }}>&nbsp;
              Time To : <br/>
              <input type="time" className="form-control" value={inputs.timeto}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              Lattitude : <br/>
              <input type="text" className="form-control" maxLength={10} value={inputs.lattitude}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              Longitude : <br/>
              <input type="text" className="form-control" maxLength={10} value={inputs.longitude}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: geoFenceDisplay }}>&nbsp;
              Radius : <span>{temeratureValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100"  value={temeratureValue} onChange={changeRangeHandler} />
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: speedingDisplay }}>&nbsp;
              Maximum Speed :(in Km/hour) <br/>
              <input type="text" className="form-control" maxLength={10} value={inputs.maxspeed}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              Lattitude : <br/>
              <input type="text" className="form-control" maxLength={10} value={inputs.lattitude1}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              Longitude : <br/>
              <input type="text" className="form-control" maxLength={10} value={inputs.longitude1}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: landMarkDisplay }}>&nbsp;
              Radius : <span>{temeratureValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100"  value={temeratureValue} onChange={changeRangeHandler} />
              </div> 
              <div class="col-sm-6 col-md-4 form-group" onChange={setIgnition_Type.bind(ignitionType)} style={{ "padding-top": "27px" ,"fontSize":"16px",display: ignitionOnDisplay }}>&nbsp;
              <input type="radio"  value="1" name="ignitionAlert" checked={ignitionType === 1?true:false}/> ON 
              &nbsp;&nbsp;<input type="radio" value="2" name="ignitionAlert" checked={ignitionType === 2?true:false}/> OFF
              </div>
              <div class="col-sm-6 col-md-4 form-group" style={{display: excessIdleDisplay }}>&nbsp;
              Minutes : <br/>
              <input type="text" className="form-control" maxLength={3} value={inputs.minutes1}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: longStopDisplay }}>&nbsp;
              Minutes : <br/>
              <input type="text" className="form-control" maxLength={3} value={inputs.minutes2}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: lateStartDisplay }}>&nbsp;
              Minutes : <br/>
              <input type="text" className="form-control" maxLength={3} value={inputs.minutes3}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: highTemperatureDisplay }}>&nbsp;
              High Temperature : <span>{temeratureValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100"  value={temeratureValue} onChange={changeRangeHandler} />
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: lowTemperatureDisplay }}>&nbsp;
              Low Temperature : <span>{temeratureValue}</span>
              <input id="alertRange" type="range" class="form-range" min="0" max="100"  value={temeratureValue} onChange={changeRangeHandler} />
              </div> 
              <div class="col-sm-6 col-md-4 form-group" style={{display: expiredDeviceDisplay }}>&nbsp;
              Expiry Date : 
              <input type="date" className="form-control" value={inputs.expirydate}  onChange={changeVHandler}/>
              </div> 
              <div class="col-sm-12 col-md-12 form-group">&nbsp;
              <center>
              <button className="btn btn-primary" onClick={() => SaveAlert()}>Save</button> 
              </center>
              </div> 
              </div>                        
              </div>
                   
            </Modal>     */}       
{/*ENd Alert Settings Popup*/}  



         {/* Filter data start */}

        
      <div className="top-bar clearfix">
        <div className="row">
          <div className="col-xs-12">
            <h2> Alerts
            <select onChange={exportDownload}  className="form-control" name="DDownload"  style={{"backgroundColor":"white",width:"8%", "float": "right","margin-right": "5px","height": "15px"}}  >
            <option value={"Download"}>Download</option>    
            <option value={"Excel"}>Excel</option>    
            <option value={"PDF"}>PDF</option>                     
            </select>
                  
            <select onChange={exportStatus} className="form-control" name="DStatus"   style={{ "backgroundColor":"white",width:"auto", "float": "right","margin-right": "5px","height": "15px"}}  value={statusId} >             
            <option value={"0"}>All</option>
            <option value={"1"}>Recent</option>
            <option value={"2"}>Acknowledged</option>             
             <option value={"3"}>Disabled</option>                    
            </select> 
           {/* <button type="submit" id="Save" onClick={() =>showDetailsModal()} className="form-control btn btn-primary float-right" style={{ "backgroundColor":"#0d6efd",color:"white" ,width:"5%", "float": "right","margin-right": "5px","height": "15px"}}> Settings </button>*/}
            </h2>
          </div>
        </div>
      </div>
    
    <div className="container-fluid p-3">
<div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">
  
      <div class="col-sm-3 col-lg-2">Vehicle#<input type="text" class="form-control" tabindex="1" id="txtTripNumber" value={SNo} onChange={changeHandler} maxlength="50"/>
      </div>
     
      <div class="col-sm-3 col-lg-2">Priority
      <select className="form-control"  name="startAddress" value={advPriority} onChange={ChangeSourceAddress} >
                            <option>Select Priority Type</option>
                            {arrayPriority.map((e, key) => 
                            {
                            return <option key={key} value={e.priorities}>{e.priorities}</option>;
                            })}
                            </select>
     </div>

      <div class="col-sm-3 col-lg-2">Alert Type
      <select className="form-control"  name="endAddress" value={advAlertType} onChange={ChangeEndAddress} >
                            <option>Select Alert Type</option>
                            {arrayAlertType.map((e, key) => {
                            return <option key={key} value={e.alertType}>{e.alertType}</option>;
                            })}
                            </select>     
      </div>
      <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnTripAdvancedSearchNew" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnTripResetAdvancedSearchNew" tabindex="7" onClick={ResetTripList}>Reset
      </button></div>
      </div>
    
  </div></div>
  {/* Filter data end  */}

      
        <div className="card mb-3 shadow no-border border-0">
        <div class="card-body">
          <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
    
          <thead>
            <tr>
                <th width="5%"  style={{textAlign:"center","cursor": "pointer"}}>S.No. </th>
                <th width="10%" onClick={()=>sorting("vehicleNumber") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Number  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="7%" onClick={()=>sorting("priorities") } style={{textAlign:"center","cursor": "pointer"}}>Priorities &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="15%" onClick={()=>sorting("alertType") } style={{textAlign:"center","cursor": "pointer"}}>Alert Type  &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="35%" onClick={()=>sorting("smsContent") } style={{textAlign:"center","cursor": "pointer"}}>Alert Description &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("receiveTime") } style={{textAlign:"center","cursor": "pointer"}}>Received Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("ackTime") } style={{textAlign:"center","cursor": "pointer"}}>Aknowledge Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="8%" onClick={()=>sorting("ackTime") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                {/* <th width="5%"  onClick={()=>sorting("id") }  style={{textAlign:"center","cursor": "pointer"}}>#</th>*/}
            </tr>
        </thead>
        <tbody>
        {currentPost.map((devdata) => {
        return (
            <>
            <tr key={devdata.id}>
              <td style={{textAlign:"center"}}>{devdata.id}</td>
              <td>{devdata.vehicleNumber}</td>
              <td  class={devdata.priorities==="Critical"?"text-danger":(devdata.priorities==="Low"?"text-success":"text-warning")}><b>{devdata.priorities}</b></td>
              <td>{devdata.alertType}</td>
              <td style={{textAlign: "left"}}>{devdata.smsContent}</td>
              <td style={{textAlign:"center"}}>{devdata.receiveTime}</td>
              <td style={{textAlign:"center"}}>{devdata.ackTime}</td>
              <td style={{textAlign:"center"}}>{devdata.status}</td>
              </tr>
              </>
                );
              })}
            </tbody>
        </table>
        <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={PageCount}
            onPageChange={ChangePage}     
            disableInitialCallback={true}
            initialPage={0}
            containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}></ReactPaginate>
            </div>  </div>  </div>
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>  
            
        </>
    );}

export default Alert;
